<template>
  <div class="modify-tel">
    <div class="page-width">
      <div class="tel-title">
        <router-link to="/personal/account">
          <h3>个人中心</h3>
        </router-link>
        <span>&nbsp;&nbsp;/&nbsp;&nbsp;绑定passport账号</span>
      </div>
      <div class="passport-content">
        <div class="com-container">
          <component
            :is="currentTabComponent"
            @bindSuccess="bindSuccess"
            :passportPhone="passportPhone"
          ></component>
        </div>
        <p>温馨提示：</p>
        <p>
          1. 绑定后，即可使用需passport账号登录的系统
          <br />2. 绑定后，不支持解绑，如需修改手机号，请前往
          <a
            href="https://passport.yunshanmeicai.com/index.php/pc/site/index?app_key=mall"
            style="color: #4272ab;"
          >passport账号平台</a>
          <br />3. 绑定手机号若无对应的passport账号，绑定后会自动注册
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Success from "./components/success";
import Binding from "./components/binding";
import Already from "./components/already";
export default {
  name: "passport",
  components: {
    Success,
    Binding,
    Already
  },
  data() {
    return {
      currentTabComponent: "",
      authPhone: "",
      passportPhone: ""
    };
  },
  created() {
    this.getPassportInfo();
  },
  methods: {
    getPassportInfo() {
      _api.personal.passportInfo().then(res => {
        if (res.data.passport_phone != null) {
          this.passportPhone = res.data.passport_phone;
          this.currentTabComponent = "Already";
        } else {
          this.currentTabComponent = "Binding";
        }
      });
    },
    bindSuccess() {
      this.currentTabComponent = "Success";
    }
  }
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  color: #4272ab;
}

.modify-tel {
  background-color: #f8f8f8;
  width: 100%;
  height: calc(100vh - 60px);
}
.page-width {
  width: 1200px;
  margin: 20px auto;
}
.tel-title {
  padding: 10px 0 20px 0px;
  display: table-cell;
  vertical-align: bottom;
  h3 {
    display: inline-block;
  }
  span {
    color: #666;
  }
}
.passport-content {
  box-shadow: 0px 1px 4px 0px rgba(176, 176, 176, 0.36);
  height: 520px;
  background-color: #fff;
  p {
    margin-left: 100px;
    line-height: 28px;
    font-size: 14px;
  }
  .com-container {
    height: 300px;
  }
}
</style>
